export const Flow = Object.freeze({
  CHAT: 'chat',
  VIDEO: 'video',
  REPORTING: 'reporting',
  PLAYBOOKS: 'playbooks',
  DEAL: 'deal',
  HYFY_MIGRATION: 'hyfy-migration',
  SALES: 'sales',
  MARKETER: 'marketer',
  ADMIN: 'admin',
  SERVICE_AGENT: 'service-agent'
})

export const RBAC_FLOWS = [
  Flow.SALES,
  Flow.MARKETER,
  Flow.ADMIN,
  Flow.SERVICE_AGENT
]

export const getSetupOrderForRbacFlow = (flow) => {
  switch(flow) {
    case Flow.SALES:
      return RbacSalesSetupOrder
    default:
      return DefaultSetupOrder
  }
}


export const MeetingsSetupOrder = [
  'setup/profile',
  'setup/password',
  'setup/meetings',
  'setup/extension',
]

export const PlaybooksRoleSetupOrder = [
  'start',
  'setup/enterprise/activate/playbooks',
  'setup/enterprise/profile/playbooks'
]

export const ReportingRoleSetupOrder = [
  'start',
  'setup/enterprise/activate/reporting',
  'setup/enterprise/profile/reporting'
]

export const RbacSalesSetupOrder = [
  'start',
  'invite/profile',
  'invite/password',
  'invite/notifications',
  'invite/personalize',
]

export const TouchlessSetupOrder = [
  'start',
  'setup/touchless/welcome',
  'setup/touchless/details',
  'setup/touchless/custom',
  'setup/touchless/install',
]

export const CalendarSeatSetupOrder = [
  'setup/calendaring/activate',
  'setup/calendaring/profile',
  'setup/calendaring/connect',
  'setup/calendaring/hooray'
]

export const DefaultSetupOrder = [
  'start',
  'invite/profile',
  'invite/password',
]
